<template>
  <b-container fluid>
    <b-row class="oscillography-analysis__diagnostics-toggle-row align-items-center">
      <b-col cols="auto">
        <b-form-group class="oscillography-analysis__toggle mb-0">
          <b-form-radio-group
            buttons
            button-variant="outline-primary"
            size="sm"
            :checked="diagnosticsMode"
            :value="diagnosticsMode"
            :options="diagnosticsModeOptions"
            @input="$emit('update:diagnosticsMode', $event)"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row
      v-if="isGraphicMode"
      class="oscillography-analysis__diagnostics-settings mx-0"
    >
      <b-col
        cols="12"
        class="d-flex justify-content-end pr-4"
      >
        <b-form-checkbox
          class="oscillography-analysis__diagnostics-checkbox"
          :checked="showExceededPoints"
          @input="$emit('update:showExceededPoints', $event)"
        >
          {{ $t('engineering.oscillography-analysis.diagnostics.mark-exceeded-points') }}
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-row v-if="isGraphicMode">
      <b-col cols="12">
        <graphic-report
          :report-data="reportData"
          :loading="loading"
          :is-default-chart="false"
          :oscillography-chart-type="oscillographyChartTypes.DIAGNOSTICS"
          :use-units-for-axes="true"
          :enable-maneuver-list-controls="true"
          :hide-installation-and-company-columns="true"
          :hide-print-button="true"
          :show-exceeded-points="showExceededPointsForChart"
          :initial-chart-filters="chartFilters"
          :show-diagnostic-context="true"
          @get-chart-data="$emit('refresh-report', $event)"
        />
      </b-col>
    </b-row>

    <b-row v-else>
      <b-col cols="12">
        <diagnostics-info-report
          :report-data="reportData"
          :loading="loading"
          :is-default-chart="false"
          :hide-search="true"
          :apply-diagnostic-limits="true"
        />
      </b-col>
    </b-row>

    <b-row
      class="oscillography-analysis__history no-internal-print"
      align-h="end"
    >
      <b-col
        cols="12"
        class="d-flex justify-content-end"
      >
        <b-button
          variant="outline-success"
          size="sm"
          :disabled="loading || !reportData.maneuvers.length"
          @click="openOscillographyHistory"
        >
          {{ $t('engineering.oscillography-analysis.history-oscillographs') }}
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import oscillographyChartTypes from '@/domain/enums/oscillographyChartTypes';
import GraphicReport from '@/domain/components/generalPanel/reports/oscillography/GraphicReport';
import DiagnosticsInfoReport from '@/domain/components/generalPanel/reports/oscillography/infoReport/DiagnosticsInfoReport';

export default {
  name: 'OscillographyAnalysisDiagnosticsTab',
  components: {
    DiagnosticsInfoReport,
    GraphicReport,
  },
  props: {
    diagnosticsMode: {
      type: String,
      default: 'graphic',
    },
    diagnosticsModeOptions: {
      type: Array,
      default: () => [],
    },
    reportData: {
      type: Object,
      default: () => ({
        chartData: [],
        diagnosticsChartData: [],
        maneuvers: [],
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showExceededPoints: {
      type: Boolean,
      default: true,
    },
    maneuverType: {
      type: String,
      default: 'opening',
    },
    chartFilters: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    oscillographyChartTypes,
  }),
  computed: {
    isGraphicMode() {
      return this.diagnosticsMode === 'graphic';
    },
    showExceededPointsForChart() {
      return this.showExceededPoints && ['opening', 'closing'].includes(this.maneuverType);
    },
  },
  methods: {
    openOscillographyHistory() {
      this.$emit('open-history');
    },
  },
};
</script>

<style lang="sass" scoped>
.oscillography-analysis
  &__history
    padding-right: 2rem

  &__diagnostics-toggle-row
    margin-top: .5rem
  &__diagnostics-settings
    margin-top: .75rem
    margin-bottom: 1rem
  &__diagnostics-checkbox
    margin-right: 0
</style>
